import { useQuery } from "@tanstack/react-query";
import { axiosInstance } from "@follosoft/react-components";

import type { AppendixResource } from "../types";

export function useContractAppendicesService(contractId?: number | string) {
  return useQuery<AppendixResource[]>({
    queryKey: ["contract-appendices", Number(contractId)],
    queryFn: async () => {
      const res = await axiosInstance().get(
        `/folloportal/contracts/${contractId}/appendices`
      );

      return res.data.data ?? [];
    },
    enabled: !!contractId,
    // The urls are signed for an hour, so let them go stale well before that.
    staleTime: 15 * 60 * 1000,
  });
}
